//Env variables..
export let BASE_URL = process.env.REACT_APP_BASE_URL;
export let SHOP_HOST = process.env.REACT_APP_SHOP_HOST;
export let REMIT_PATH = process.env.REACT_APP_REMIT_PATH;
export let WALLET_URL = process.env.REACT_APP_WALLET_URL;